'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';
import { Tooltip } from '@/components/elementary/Tooltip';
import { Facebook } from '@/components/icons/social/Facebook';
import { LinkedIn } from '@/components/icons/social/LinkedIn';
import { Twitter } from '@/components/icons/social/Twitter';
import { CopyContent } from '@/components/page-builder/blog/CopyContent';
import { getOriginUrl } from '@/lib/general-helpers';
import { removeHtmlTags } from '@/lib/html';
import { ARTICLE_SHARE_ICONS_TEST_IDS } from '@/lib/test-ids';
export function ShareIcons(t0) {
  const $ = _c(11);
  const {
    title,
    url
  } = t0;
  let shareUrl;
  if ($[0] !== url) {
    const isAbsoluteHttp = /^https?:\/\//i.test(url);
    shareUrl = getShareUrl(url, isAbsoluteHttp);
    function getShareUrl(url_0, isAbsoluteHttp_0) {
      if (!url_0) {
        return getCurrentUrl();
      }
      return isAbsoluteHttp_0 ? url_0 : new URL(url_0, getOriginUrl()).toString();
    }
    function getCurrentUrl() {
      if (typeof window !== "undefined") {
        return window.location.href;
      }
      return getOriginUrl();
    }
    $[0] = url;
    $[1] = shareUrl;
  } else {
    shareUrl = $[1];
  }
  const t = useTranslations("ShareIcons");
  let t1;
  if ($[2] !== shareUrl || $[3] !== t || $[4] !== title) {
    t1 = shareIconsMap.map(t2 => {
      const {
        icon: Icon,
        tooltip,
        component: Component
      } = t2;
      return <Tooltip key={tooltip} content={t(tooltip)} asChild={true}><Component url={shareUrl} title={removeHtmlTags(title)} aria-label={t(tooltip)}><Icon className="text-neutral-light-alpha-500" /></Component></Tooltip>;
    });
    $[2] = shareUrl;
    $[3] = t;
    $[4] = title;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== shareUrl) {
    t2 = <CopyContent shareUrl={shareUrl} />;
    $[6] = shareUrl;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <div className="flex items-center gap-3" data-test-id={ARTICLE_SHARE_ICONS_TEST_IDS.COMPONENT}>{t1}{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
const shareIconsMap = [{
  icon: Twitter,
  tooltip: 'twitter' as const,
  component: TwitterShareButton
}, {
  icon: Facebook,
  tooltip: 'facebook' as const,
  component: FacebookShareButton
}, {
  icon: LinkedIn,
  tooltip: 'linkedIn' as const,
  component: LinkedinShareButton
}] as const;